import { useMemo } from 'react';
import { getBoatTimesOptions, getTimeOptions } from '../utils';
import { useTimePickerData } from './useTimePickerData';
import { TimePickerProps } from '../types';

export const useTimeOptions = (
  props: Pick<TimePickerProps, 'calendar' | 'useDuration'>,
  data: ReturnType<typeof useTimePickerData>,
  timepickerTestFlag: boolean
) => {
  const { calendar, useDuration } = props;
  const {
    tripStart,
    tripStartFormatted,
    defaultStartTimes,
    bookingBoatDetails,
    bookingDuration,
    selectedBookingPackage,
  } = data;

  return useMemo(() => {
    const boatTimesOptions = getBoatTimesOptions(
      tripStart,
      defaultStartTimes,
      bookingBoatDetails?.start_times || {},
      calendar,
      !timepickerTestFlag
    );

    return getTimeOptions({
      startDate: tripStartFormatted,
      calendar,
      timeOptions: boatTimesOptions,
      defaultStartTimes,
      useDuration,
      bookingDuration,
      selectedBookingPackage,
      hideUnavilableTimes: !timepickerTestFlag,
    });
  }, [
    tripStart,
    tripStartFormatted,
    calendar,
    defaultStartTimes,
    useDuration,
    bookingBoatDetails?.start_times,
    bookingDuration,
    selectedBookingPackage,
    timepickerTestFlag,
  ]);
};
